"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import format from "../../formatters/general";
import fetch from "../../util/fetch";
import LineItem, { validId } from "./line_item";
import { List, Map } from "immutable";
import { Flash } from "../../components/flash";
import Api from "../../api/api";
import possibleNonCalculatedAlertIcon from "../ui/line_item_ignored_item_icon";
import lineItemsForCalculation from "../data/line_items_for_calculation";
import quickpayHelper from "../../helpers/quickpay";
import CarrierService from "../../services/carrier_service";
const didChange = (item, field, value) => {
  return parseFloat(item[field]) !== parseFloat(value);
};
const getTotal = (items) => {
  return items.reduce((memo, item) => {
    return memo + parseFloat(item.total);
  }, 0);
};
const fetchLineItems = (carrierInvoiceId) => {
  return fetch(`/api/carrier_invoices/${carrierInvoiceId}/line_items`).then(
    (data) => data
  );
};
function totalChanged(props) {
  var _a;
  (_a = props.invoiceChangeComplete) == null ? void 0 : _a.call(props);
}
function saveLineItem(props, lineItem) {
  const id = lineItem.id || "";
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/line_items/${id}`,
    {
      method: validId(lineItem.id) ? "put" : "post",
      data: {
        tms_line_item: lineItem,
        creating_load: props.creatingLoad
      }
    }
  ).then((data) => data);
}
function deleteItem(props, item) {
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/line_items/${item.id}`,
    {
      method: "delete",
      data: { creating_load: props.creatingLoad }
    }
  ).then((data) => data);
}
function readOnly(props) {
  return carrierInvoice(props).state == "approved" || carrierInvoice(props).state == "abandoned" || !props.creatingLoad && Api.Account.shouldShowReadOnlyLineItems();
}
function shouldShowReplaceLineItemsDisplay(props, state) {
  if (readOnly(props) || !loadHasLineItems(props)) {
    return false;
  }
  return (!state.lineItemsMatch || state.tmsUpdatedLoad) && !props.creatingLoad;
}
function loadHasLineItems(props) {
  return !_.isEmpty(props.load.load.line_items);
}
function carrierInvoice(props) {
  return props.carrierInvoice;
}
function carrier(props) {
  return CarrierService.getCarrierOrUnknown(carrierInvoice(props).carrier_id);
}
function quickpayDiscountAmount(props) {
  return quickpayHelper.quickpayDiscountAmount(
    invoiceAmount(props),
    carrier(props)
  );
}
function invoiceAmount(props) {
  var amount = parseFloat(
    carrierInvoice(props).amountToPay || carrierInvoice(props).source_invoice_amount
  );
  return isNaN(amount) ? 0 : amount;
}
function replaceLineItemsMessage(state) {
  if (state.tmsUpdatedLoad) {
    return "Line items for this load have been modified in the TMS.";
  } else if (!state.lineItemsMatch) {
    return "Line items do not match line items from load.";
  }
}
function replaceItems(props) {
  return fetch(
    `/api/carrier_invoices/${carrierInvoice(props).id}/replace_line_items`,
    {
      method: "post"
    }
  ).then((data) => data);
}
function noItems(state) {
  if (state.lineItems.isEmpty()) {
    return /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx("div", { className: "alert-box secondary", children: "No line items." }) });
  }
}
function hasQuickpayAdjustment(props) {
  return quickpayHelper.hasQuickpayAdjustment(
    carrierInvoice(props),
    carrier(props)
  );
}
function possibleQuickpayBreakdown(props) {
  if (carrierInvoice(props).quickpay_disposition == "not_applied_to_invoice" && hasQuickpayAdjustment(props)) {
    return /* @__PURE__ */ jsxs("div", { className: "row", children: [
      /* @__PURE__ */ jsxs("div", { className: "small-3 column possible-adjustments__calculation-line", children: [
        /* @__PURE__ */ jsx("div", { className: "operation", children: "-" }),
        format.currency(quickpayDiscountAmount(props))
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "small-7 column", children: [
        quickpayHelper.quickpayDiscountAmountUsed(
          invoiceAmount(props),
          carrier(props)
        ),
        " ",
        "Quickpay Discount"
      ] })
    ] });
  } else {
    return null;
  }
}
function lineItemTotal(state) {
  return getTotal(state.lineItems);
}
function lineItemDiff(props, state) {
  let diff = lineItemTotal(state) - props.payment.amount;
  if (carrierInvoice(props).quickpay_disposition == "not_applied_to_invoice") {
    diff -= quickpayDiscountAmount(props);
  }
  return diff;
}
class LineItems extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: true,
      lineItems: List([]),
      lineItemsMatch: true,
      tmsUpdatedLoad: false,
      hasIgnoredLineItems: false
    });
    __publicField(this, "mounted", false);
    __publicField(this, "updateItem", (item, field, value) => {
      const idx = this.state.lineItems.indexOf(item);
      const items = this.state.lineItems;
      const newItem = Map(item).set(field, value).toJS();
      if (!validId(newItem.tms_line_item_type_id) || !didChange(item, field, value)) {
        return Promise.resolve();
      }
      return saveLineItem(this.props, newItem).then((data) => {
        var savedItem = data.tms_line_item;
        const newItems = items.update(idx, () => savedItem);
        this.setState({ lineItems: newItems });
        this.updateMatchData(data.match_results);
        totalChanged(this.props);
        return savedItem;
      });
    });
    __publicField(this, "setStateAndCallback", (items) => {
      var _a;
      const calculationLineItems = lineItemsForCalculation(
        items,
        Api.Account.currentSettings().ignore_adjustment_line_items
      );
      const hasIgnoredLineItems = calculationLineItems.length !== items.length;
      const lineItemsList = List(calculationLineItems);
      this.setState({
        lineItems: lineItemsList,
        hasIgnoredLineItems
      });
      if (((_a = this.props.carrierInvoice) == null ? void 0 : _a.state) !== "approved") {
        totalChanged(this.props);
      }
      return lineItemsList;
    });
    __publicField(this, "getLineItems", (carrierInvoiceId) => {
      return fetchLineItems(carrierInvoiceId).then((data) => {
        this.updateMatchData(data.match_results);
        return this.setStateAndCallback(data.tms_line_items);
      });
    });
    __publicField(this, "addItem", () => {
      const newItem = {
        description: "",
        total: 0,
        new: true,
        id: "",
        tms_data: { rate_qualifier: "FR" }
      };
      const newItems = this.state.lineItems.push(newItem);
      this.setState({ lineItems: newItems });
    });
    __publicField(this, "updateMatchData", (match_results) => {
      this.setState({
        lineItemsMatch: match_results.line_items_match,
        tmsUpdatedLoad: match_results.tms_updated_load
      });
    });
    __publicField(this, "removeItem", (item) => {
      return () => {
        const lineItems = this.state.lineItems;
        const newItems = lineItems.delete(lineItems.indexOf(item));
        this.setState({ lineItems: newItems });
        totalChanged(this.props);
        if (validId(item.id)) {
          deleteItem(this.props, item).then((data) => {
            this.updateMatchData(data.match_results);
            Flash.success("Item deleted successfully!");
          }).catch(() => {
            Flash.warning("There was a problem deleting the item");
            this.setState({ lineItems });
          });
        }
      };
    });
    __publicField(this, "getLineItemTypes", () => {
      return fetch("/api/line_item_types").then((data) => {
        if (this.mounted) {
          this.setState({
            lineItemTypes: data.line_item_types
          });
        }
        return data;
      });
    });
    __publicField(this, "getData", (props) => {
      Promise.all([
        this.getLineItemTypes(),
        this.getLineItems(props.carrierInvoice.id)
      ]).then(() => {
        this.setState({ loading: false });
      });
    });
    __publicField(this, "possibleAddItemLink", () => {
      if (!readOnly(this.props)) {
        return /* @__PURE__ */ jsx("a", { onClick: this.addItem, children: /* @__PURE__ */ jsx("i", { className: "fi-plus" }) });
      }
    });
    __publicField(this, "possibleReplaceLineItemsDisplay", () => {
      if (shouldShowReplaceLineItemsDisplay(this.props, this.state)) {
        return /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsxs("div", { className: "alert-box--caution line-items__replace-alert", children: [
          replaceLineItemsMessage(this.state),
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.replaceLineItems,
              className: "line-items__replace-button",
              children: "Replace Line Items"
            }
          )
        ] }) });
      }
    });
    __publicField(this, "replaceLineItems", () => {
      replaceItems(this.props).then((data) => {
        this.updateMatchData(data.match_results);
        this.setStateAndCallback(data.tms_line_items);
        Flash.success("Line Items Replaced Successfully!");
      });
    });
    __publicField(this, "lineItems", () => {
      return this.state.lineItems.map(this.lineItem);
    });
    __publicField(this, "lineItem", (lineItem, idx) => {
      if (!this.state.loading) {
        return /* @__PURE__ */ jsx(
          LineItem,
          {
            readOnly: readOnly(this.props),
            creatingLoad: this.props.creatingLoad,
            lineItem,
            updateItem: this.updateItem,
            removeItem: this.removeItem,
            lineItemTypes: this.state.lineItemTypes
          },
          "line-item-" + (!validId(lineItem.id) ? `new-${idx}` : lineItem.id)
        );
      }
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.getData(this.props);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentDidUpdate(prevProps) {
    if (this.props.carrierInvoice.id !== carrierInvoice(prevProps).id) {
      this.getData(this.props);
    }
  }
  // RENDERING
  render() {
    const ignoreAdjustmentLineItems = Api.Account.currentSettings().ignore_adjustment_line_items;
    return /* @__PURE__ */ jsx("div", { "data-component": "LineItems", className: "line-items", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
      /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsxs("label", { className: "line-item-header", children: [
        "Line items ",
        this.possibleAddItemLink()
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: "line-items__alerts-container", children: [
        this.possibleReplaceLineItemsDisplay(),
        possibleNonCalculatedAlertIcon(
          this.state.hasIgnoredLineItems,
          ignoreAdjustmentLineItems,
          true
        ),
        noItems(this.state)
      ] }),
      this.lineItems(),
      /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx("div", { className: "row possible-adjustments__container", children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: "small-5 small-offset-5 column\n                              possible-adjustments__factor-calculation",
          children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: "row\n                             possible-adjustments__starting-calculation-line",
                children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "small-3 column\n                                  possible-adjustments__starting-amount",
                      children: format.currency(this.props.payment.amount)
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: "small-7 column", children: "Payment Amount" })
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: "row\n                              possible-adjustments__starting-calculation-line",
                children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "small-3 column\n                                  possible-adjustments__starting-amount",
                      children: format.currency(lineItemTotal(this.state))
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: "small-7 column", children: "Line Item Total" })
                ]
              }
            ),
            possibleQuickpayBreakdown(this.props),
            /* @__PURE__ */ jsxs("div", { className: "row possible-adjustments__factor-total-line", children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "small-3 column\n                                  possible-adjustments__total-amount",
                  children: format.currency(lineItemDiff(this.props, this.state))
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "small-7 column possible-adjustments__total-label", children: "Difference" })
            ] })
          ]
        }
      ) }) })
    ] }) });
  }
}
export default LineItems;
